import { render, staticRenderFns } from "./AgateProjects.vue?vue&type=template&id=dc0deef8&"
import script from "./AgateProjects.vue?vue&type=script&lang=js&"
export * from "./AgateProjects.vue?vue&type=script&lang=js&"
import style0 from "./AgateProjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports